import { WatchQueryFetchPolicy } from '@apollo/client';

import { useGetHomepageOrderStateQuery } from 'generated/graphql-gateway';
import { useAuthContext } from 'state/auth';

export const useGetHomepageOrderState = (
  fetchPolicy: WatchQueryFetchPolicy = 'cache-and-network',
  skip?: boolean
) => {
  const { isAuthenticated } = useAuthContext();
  const { data, error, loading, refetch } = useGetHomepageOrderStateQuery({
    context: { shouldNotBatch: true },
    skip: !isAuthenticated || skip,
    fetchPolicy,
  });

  return {
    error,
    homepageOrderState: data?.homepageOrderState,
    loading,
    refetch,
  };
};
